module.exports = "https://static.energy5.com/_next/static/images/e2-93378d47b9615584ca20a7d00b7b12a2.png";